import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentTable: {
    eurocode: "Bohrkronen",
    aashto: "Carrying elements",
    products: "Products",
    edp: "GWP", // Adding the edp property with default value
  },
  addNewState: false,
};

const dataTablesSlice = createSlice({
  name: "datatables",
  initialState,
  reducers: {
    setCurrentTable(state, action) {
      state.currentTable = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setAddNewState(state, action) {
      state.addNewState = action.payload;
    },
  },
});

export const { setCurrentTable, setPageSize, setCurrentPage, setAddNewState } =
  dataTablesSlice.actions;
export default dataTablesSlice.reducer;

export const selectCurrentTable = (state) => state.datatables.currentTable;
//export const selectTables = (state) => state.datatables.tables;
export const selectAddNewState = (state) => state.datatables.addNewState;
